<template>
  <form @submit.prevent="updateSku">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Item SKU</p>
      </header>
      <section class="modal-card-body">
        <div v-if="!loading && item !== null">
          <!-- Variant Details -->
          <div>
            <p class="mb-sm"><strong>Item Details</strong></p>
            <table class="table is-fullwidth is-striped is-size-7 is-narrow border mb-xl">
              <tbody>
                <tr>
                  <th>ID</th>
                  <td class="has-text-right">{{ item.id }}</td>
                </tr>
                <tr>
                  <th>Current Item SKU</th>
                  <td class="has-text-right">{{ item.brand_identifier }}</td>
                </tr>
                <tr>
                  <th>UPC</th>
                  <td class="has-text-right">{{ item.upc }}</td>
                </tr>
                <tr>
                  <th>Supplier Item Name</th>
                  <td class="has-text-right">{{ item.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- SKU -->
          <div>
            <b-field label="New SKU">
              <b-input
                type="text"
                name="identifier"
                v-model="identifier"
                placeholder="Enter new SKU here..."
                size="is-medium"
              ></b-input>
            </b-field>
          </div>
          <!-- Requires Shipping -->
          <div class="mt-4">
            <b-field label="Requires Shipping">
              <b-select v-model="requiresShipping" placeholder="Select a value" expanded size="is-medium">
                <option :value="true">True</option>
                <option :value="false">False</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div v-else>
          <loading message="Loading current item details..." />
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          native-type="submit"
          type="is-primary"
          :disabled="saving || !ready"
          :loading="saving"
        >Update Item</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      loading: false,
      identifier: null,
      requiresShipping: this.item?.requires_shipping != null ? Boolean(this.item.requires_shipping) : false,
      initialRequiresShipping: null,
      saving: false,
      errors: {}
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/variants/' + this.item.id + '/'
    },
    requiresShippingChanged () {
      return this.requiresShipping !== this.initialRequiresShipping
    },
    json () {
      const payload = {}
      if (this.identifier) payload.identifier = this.identifier
      if (this.requiresShippingChanged) payload.requires_shipping = this.requiresShipping
      return payload
    },
    ready () {
      return !!this.identifier || this.requiresShippingChanged
    }
  },
  methods: {
    updateSku () {
      this.saving = true
      this.$http.patch(this.endpoint, this.json).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Item updated!' })
        this.$parent.close()
      }).finally(() => {
        this.$emit('item:updated')
        this.saving = false
      })
    }
  },
  mounted () {
    this.initialRequiresShipping = this.item?.requires_shipping != null ? Boolean(this.item.requires_shipping) : false
  },
  props: ['item']
}
</script>
